<template>
    <div class="page">
        <div class="card">
            <img src="/resources/logo.png" class="logo" />

            <h1 class="title">D3 移动应用</h1>
            <p class="desc">
                为获得完整功能与更流畅的体验，请下载安装 App 使用。
            </p>

            <!-- 微信提示 -->
            <div v-if="isWeChat" class="wechat-tip">
                <p>请点击右上角 ···</p>
                <p>选择 <b>“在浏览器中打开”</b> 后下载应用</p>
            </div>

            <!-- 下载按钮 -->
            <a v-else href="https://mobile.d3inf.com/d3.apk" target="_blank" rel="noopener noreferrer" download
                class="download-btn">
                点击下载 APK
            </a>
            <!-- <a
        v-else
        class="download-btn"
        @click="downloadApp"
      >
        立即下载 Android 版
    </a> -->

            <!-- <div class="meta">
        <p>版本：v1.0.0</p>
        <p>大小：18.5 MB</p>
      </div> -->
        </div>

        <footer class="footer">
            <a href="/privacy.html">隐私政策</a>
            <span> · </span>
            <a href="/agreement.html">用户协议</a>
        </footer>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const isWeChat = ref(false)

onMounted(() => {
    const ua = navigator.userAgent.toLowerCase()
    isWeChat.value = ua.includes('micromessenger')
})

const downloadApp = () => {
    // 注意：这里不要写绝对 APK 地址，写相对路径
    window.location.href = 'https://mobile.d3inf.com/d3.apk'
}
</script>

<style scoped>
.page {
    min-height: 100vh;
    background: linear-gradient(135deg, #f5f7fa, #e4ecf5);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.card {
    /* margin: auto; */
    height: 99vh;
    /* width: 92%;
  max-width: 420px; */
    background: #ffffff;
    border-radius: 20px;
    padding: 40px 28px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
    text-align: center;
}

.logo {
    width: 88px;
    height: 88px;
    margin-bottom: 20px;
}

.title {
    font-size: 26px;
    font-weight: 600;
    margin-bottom: 12px;
    color: #222;
}

.desc {
    font-size: 15px;
    color: #666;
    margin-bottom: 28px;
    line-height: 1.6;
}

.wechat-tip {
    background: #fff8e6;
    border: 1px solid #ffe0a3;
    color: #8a5b00;
    padding: 18px;
    border-radius: 12px;
    font-size: 14px;
    line-height: 1.6;
}

.download-btn {
    width: 100%;
    padding: 16px 0;
    border-radius: 12px;
    border: none;
    font-size: 16px;
    font-weight: 600;
    background: #1677ff;
    color: white;
    cursor: pointer;
    transition: all 0.2s ease;
    padding: 16px;
}

.download-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(22, 119, 255, 0.3);
}

.meta {
    margin-top: 22px;
    font-size: 13px;
    color: #999;
}

.footer {
    text-align: center;
    padding: 18px 0 30px;
    font-size: 13px;
    color: #999;
}

.footer a {
    color: #666;
    text-decoration: none;
}
</style>